<template>
  <div class="tb-nav">
    <button
      type="button"
      class="tb-nav__item tb-nav__back"
      @click="goToList"
    >
      <i class="material-icons-round">arrow_back</i>
      <span>목록</span>
    </button>
    <span class="tb-nav__divider"></span>
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="tb-nav__item"
      :class="{ 'is-active': activeTab === tab.id }"
      @click="navigateTo(tab)"
    >
      <i class="material-icons-round">{{ tab.icon }}</i>
      <span>{{ $t(tab.i18nKey) }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "TextbookPageNav",
  props: {
    barcode: { type: String, required: true },
    activeTab: {
      type: String,
      required: true,
      validator: (value) => ["textbook", "contents", "words"].includes(value),
    },
  },
  data() {
    return {
      tabs: [
        { id: "textbook", i18nKey: "txt.10",    icon: "edit",        route: "EditTextbook" },
        { id: "contents", i18nKey: "label.38",  icon: "description", route: "EditTextbookContents" },
        { id: "words",    i18nKey: "label.76",  icon: "spellcheck",  route: "EditWordsAndExpressions" },
      ],
    };
  },
  methods: {
    // 목록으로 이동 (목록에서 넘어온 page 쿼리 보존)
    goToList() {
      const query = this.$route.query.page ? { page: this.$route.query.page } : {};
      this.$router.push({ name: "ContentsTextbooks", query });
    },
    navigateTo(tab) {
      if (this.activeTab === tab.id) return;
      // 탭 이동 시에도 page 쿼리를 보존하여 목록 복귀 위치 유지
      const query = { barcode: this.barcode };
      if (this.$route.query.page) query.page = this.$route.query.page;
      this.$router.push({ name: tab.route, query });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.tb-nav {
  display: inline-flex;
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-md;
  padding: 4px;
  gap: 2px;
  margin-bottom: 14px;

  &__item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 0;
    background: transparent;
    color: $p-ink-mid;
    font-family: $p-font-body;
    font-size: 13px;
    font-weight: 700;
    border-radius: $p-radius;
    cursor: pointer;
    transition: background $p-dur $p-ease, color $p-dur $p-ease;

    > i { font-size: 16px; }

    &:hover {
      background: $p-panel-alt;
      color: $p-ink;
    }

    &.is-active {
      background: $p-ink;
      color: $p-point;
    }
  }

  &__back {
    color: $p-ink-mid;

    > i { font-size: 18px; }
  }

  &__divider {
    align-self: stretch;
    width: 1px;
    margin: 4px 2px;
    background: $p-line;
  }
}
</style>
